import { Number, NumberWrap, StyledInput, WrapperPhone } from "./style";
import InputMask from "react-input-mask";
import Label from "../style";

const Phone = ({ value, onChange, label, name, status, ...rest }) => {
  const handleFocus = () => {
    // setIsFocused(true);
  };

  const handleBlur = () => {
    // setIsFocused(false);
  };

  return (
    <WrapperPhone>
      <Label htmlFor={name} title={label} />
      <NumberWrap>
        <Number>+998</Number>

        <InputMask
          mask="(99)-999-99-99"
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          value={value}
          name={name}
        >
          {(inputProps) => (
            <StyledInput
              {...rest}
              {...inputProps}
              id={name}
              status={status}
              // isFocused={isFocused}
              aria-label={label}
            />
          )}
        </InputMask>
      </NumberWrap>
    </WrapperPhone>
  );
};

export default Phone;
